import React from 'react';
import { CheckCircle, AlertCircle, Info, X } from 'lucide-react';

const VARIANTS = {
  success: {
    icon: CheckCircle,
    iconCls: 'text-emerald-500',
    btn: 'bg-emerald-600 hover:bg-emerald-700',
  },
  error: {
    icon: AlertCircle,
    iconCls: 'text-red-500',
    btn: 'bg-red-600 hover:bg-red-700',
  },
  info: {
    icon: Info,
    iconCls: 'text-blue-500',
    btn: 'bg-blue-600 hover:bg-blue-700',
  },
};

const NotificationModal = ({ variant = 'info', title, message, onClose, onConfirm, confirmLabel = 'Confirm' }) => {
  const cfg = VARIANTS[variant] || VARIANTS.info;
  const Icon = cfg.icon;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm mx-4 overflow-hidden">
        <div className="p-6">
          <div className="flex items-start gap-4">
            <Icon className={`w-6 h-6 flex-shrink-0 mt-0.5 ${cfg.iconCls}`} />
            <div className="flex-1 min-w-0">
              {title && (
                <h3 className="text-base font-semibold text-gray-900 mb-1">{title}</h3>
              )}
              {message && (
                <p className="text-sm text-gray-600 whitespace-pre-line">{message}</p>
              )}
            </div>
            <button
              onClick={onClose}
              className="flex-shrink-0 p-1 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <X className="w-4 h-4 text-gray-400" />
            </button>
          </div>
        </div>
        <div className="px-6 pb-5 flex justify-end gap-2">
          {onConfirm ? (
            <>
              <button
                onClick={onClose}
                className="px-5 py-2 rounded-lg text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={onConfirm}
                className={`px-5 py-2 rounded-lg text-sm font-medium text-white transition-colors ${cfg.btn}`}
              >
                {confirmLabel}
              </button>
            </>
          ) : (
            <button
              onClick={onClose}
              className={`px-5 py-2 rounded-lg text-sm font-medium text-white transition-colors ${cfg.btn}`}
            >
              OK
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationModal;
